// Shared UI copy reused across filters, detail sections, and summary cards.

export const UI_TEXT_EMPTY_VALUE = '-'
export const UI_TEXT_EM_DASH = '—'
export const UI_TEXT_NA = 'N/A'
export const UI_TEXT_NO_CODE = 'Sin código'
export const UI_TEXT_NO_BARCODE = 'Sin código de barra'
export const UI_TEXT_VALID_QUANTITY = 'Cantidad válida'

export const UI_TEXT_YES = 'Sí'
export const UI_TEXT_NO = 'No'

export const UI_TEXT_CANCEL = 'Cancelar'
export const UI_TEXT_CONFIRM = 'Confirmar'

export const UI_TEXT_SEARCH_PLACEHOLDER = 'Buscar ...'
export const UI_TEXT_CLEAR_SEARCH = 'Limpiar búsqueda'

export const UI_TEXT_COPY_TABLE = 'Copiar tabla'
export const UI_TEXT_TABLE_COPIED = 'Tabla copiada'
export const UI_TEXT_DOWNLOAD_TABLE = 'Descargar tabla'
export const UI_TEXT_DOWNLOADING = 'Descargando...'

export const UI_TEXT_ATTACHMENTS = 'ADJUNTO(S)'
export const UI_TEXT_NO_RESULTS = 'No hay resultados.'
export const UI_TEXT_LOADING = 'Cargando...'
export const UI_TEXT_STATUS = 'Estado:'

export const UI_TEXT_SUMMARY = 'RESUMEN'
export const UI_TEXT_PROGRESS = 'Progreso'
export const UI_TEXT_PENDING = 'Pendientes'

export const UI_TEXT_DETAILS = 'DETALLES'
export const UI_TEXT_ADDITIONAL_DATA = 'DATOS ADICIONALES'

export const UI_TEXT_OPEN_DETAILS = 'Abrir detalles'
export const UI_TEXT_CLOSE_DETAILS = 'Cerrar detalles'
export const UI_TEXT_OPEN_ADDITIONAL_DATA = 'Abrir datos adicionales'
export const UI_TEXT_CLOSE_ADDITIONAL_DATA = 'Cerrar datos adicionales'
